(function (Drupal, drupalSettings) {
  Drupal.behaviors.gallery = {
    attach: function (context, settings) {
      const galleries = context.querySelectorAll(
        ".paragraph--reference_realisation"
      );
      galleries.forEach((gallery) => {
        if (!gallery.dataset.galleryProcessed) {
          gallery.dataset.galleryProcessed = "true";

          const gridItems = gallery.querySelectorAll(".grid-item");
          const moreButton = gallery.querySelector(".more");
          const grid = gallery.querySelector(".grid");

          let x = 12;
          const nbrEl = gridItems.length;

          if (nbrEl <= x && moreButton) {
            moreButton.style.display = "none";
          }

          gridItems.forEach((item, index) => {
            if (index >= 12) {
              item.style.display = "none";
            }
          });

          imagesLoaded(grid, () => {
            const msnry = new Masonry(grid, {
              itemSelector: ".grid-item",
              columnWidth: ".grid-sizer",
              percentPosition: true,
            });

            if (moreButton) {
              const moreLink = moreButton.querySelector("a");
              if (moreLink) {
                moreLink.addEventListener("click", (e) => {
                  e.preventDefault();
                  x = Math.min(x + 12, nbrEl);

                  if (x === nbrEl) {
                    moreButton.style.display = "none";
                  }

                  gridItems.forEach((item, index) => {
                    if (index < x) {
                      item.style.display = "";
                      msnry.layout();
                    }
                  });
                });
              }
            }
          });

          Drupal.behaviors.gallery.getContentGallery();
        }
      });
    },
    getContentGallery: function () {
      document.addEventListener("click", (e) => {
        if (e.target.closest(".item-gallery")) {
          e.preventDefault();
          const item = e.target.closest(".item-gallery");
          const modal = document.getElementById("galleryModal");
          const swiperWrapper = modal.querySelector(".swiper-wrapper");
          const modalContent = modal.querySelector(".modal-content");

          swiperWrapper.innerHTML = "";
          const descElement = modalContent.querySelector(".desc");
          if (descElement) {
            descElement.remove();
          }

          const title = item.dataset.title;
          const content = item.dataset.content;
          const carousel = item.dataset.carousel.split(",");

          carousel.forEach((src, index) => {
            const slide = document.createElement("div");
            slide.className = "swiper-slide";
            slide.innerHTML = `<img class="img-fluid" src="${src}" alt="Gallery ${
              index + 1
            }">`;
            swiperWrapper.appendChild(slide);
          });

          if (title || content) {
            const desc = document.createElement("div");
            desc.className = "desc";

            if (title) {
              const h3 = document.createElement("h3");
              h3.textContent = title;
              desc.appendChild(h3);
            }

            if (content) {
              const p = document.createElement("p");
              p.textContent = content;
              desc.appendChild(p);
            }

            modalContent.appendChild(desc);
          }

          new Swiper(".swiper-realisations", {
            slidesPerView: 1,
            autoHeight: true,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
          });

          modal.classList.add("open");
        }
      });
    },
  };
})(Drupal, drupalSettings);
